import React from 'react';
import BannerSectionStyle5 from '../Section/BannerSection/BannerSectionStyle5';
import TeamSectionStyle2 from '../Section/TeamSection/TeamSectionStyle2';
import Section from '../Section';
import { pageTitle } from '../../helpers/PageTitle';
import CliniciansImageSection from './CliniciansImageSection';

const teamData = [
  // ...existing team data...
];

export default function Clinicians() {
  pageTitle('Clinicians');
  return (
    <>
      <BannerSectionStyle5
        bgUrl="/images/doctors/banner_bg.jpg"
        imgUrl="/images/doctors/banner_img.png"
        title="Clinicians"
        subTitle="We don’t follow paths<br /> We define them"
      />
      <Section topMd={65} bottomMd={200} bottomLg={150} bottomXl={110}>
        <CliniciansImageSection />
        {/* <TeamSectionStyle2 data={teamData} /> */}
      </Section>
    </>
  );
}
